(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/components/teams-wait-for-backend.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/components/teams-wait-for-backend.js');
'use strict';

const logger = svs.arena.logger;
const Loader = svs.components.ReactLoader.Loader;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const _svs$arena$store$team = svs.arena.store.teams.actions,
  fetchTeams = _svs$arena$store$team.fetchTeams,
  fetchTeamsDetails = _svs$arena$store$team.fetchTeamsDetails,
  setTeamBalance = _svs$arena$store$team.setTeamBalance;
const _svs$arena$constants = svs.arena.constants,
  routes = _svs$arena$constants.routes,
  MAX_RETRIES_FOR_BACKEND = _svs$arena$constants.MAX_RETRIES_FOR_BACKEND;
const showTechnicalErrorGettingTeams = svs.arena.pages.teams.dialogs.showTechnicalErrorGettingTeams;
const TeamsWaitForBackend = () => {
  const dispatch = ReactRedux.useDispatch();
  const history = useHistory();
  svs.utils.url.refreshQueryString();
  logger.debug('**** TeamsWaitForBackend, refreshQueryString: ', svs.utils.url.queryString);
  const tryToGetMyTeam = async attempt => {
    var _teamsNew$payload, _detailsNew$payload;
    const teamId = svs.utils.url.queryString.teamId;
    const syndicateBalance = svs.utils.url.queryString.tb;
    const memberBalance = svs.utils.url.queryString.mb;
    const playableAmount = svs.utils.url.queryString.pa;
    logger.debug('**** TeamsWaitForBackend, teamId: ', teamId);
    if (teamId === undefined) {
      logger.debug('**** tryToGetMyTeam, url-param teamId is undefined, navigate to My Teams ');
      history.push(routes.TEAMS);
      return;
    }
    const createdTeamId = parseInt(teamId, 10);
    const teamsNew = await dispatch(fetchTeams());
    const detailsNew = await dispatch(fetchTeamsDetails());
    const foundTeam = teamsNew === null || teamsNew === void 0 || (_teamsNew$payload = teamsNew.payload) === null || _teamsNew$payload === void 0 || (_teamsNew$payload = _teamsNew$payload.data) === null || _teamsNew$payload === void 0 ? void 0 : _teamsNew$payload.find(team => team.syndicateId === createdTeamId);
    const foundDetails = detailsNew === null || detailsNew === void 0 || (_detailsNew$payload = detailsNew.payload) === null || _detailsNew$payload === void 0 || (_detailsNew$payload = _detailsNew$payload.data) === null || _detailsNew$payload === void 0 ? void 0 : _detailsNew$payload.find(team => team.syndicateId === createdTeamId);
    logger.debug('**** tryToGetMyTeam, teamsNew, createdTeamId: ', teamsNew, createdTeamId, foundTeam);
    if (foundTeam && foundDetails) {
      if (memberBalance && memberBalance !== 'undefined') {
        dispatch(setTeamBalance({
          teamId: createdTeamId,
          memberBalance,
          syndicateBalance,
          playableAmount
        }));
      }
      logger.debug('**** tryToGetMyTeam, foundTeam yes!, navigate to my teams');
      history.push(routes.TEAMS);
    } else {
      logger.debug('**** tryToGetMyTeam, did NOT foundTeam, attempt of: ', attempt, MAX_RETRIES_FOR_BACKEND);
      if (attempt < MAX_RETRIES_FOR_BACKEND) {
        setTimeout(() => {
          logger.debug('**** tryToGetMyTeam, trying one more time...');
          tryToGetMyTeam(attempt + 1);
        }, 1000);
      } else {
        showTechnicalErrorGettingTeams();
        history.push(routes.TEAMS);
      }
    }
  };
  React.useEffect(() => {
    tryToGetMyTeam(0);
  }, []);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "align-center margin-top-4"
  }, "\xA0"), React.createElement("div", {
    className: "align-center margin-top-4"
  }, "\xA0"), React.createElement("div", {
    className: "margin-top-1"
  }, React.createElement(Loader, {
    size: 300
  })), React.createElement("div", {
    className: "margin-top-2 align-center"
  }, "H\xE4mtar dina lag..."));
};
svs.arena.pages.teams.components.TeamsWaitForBackend = TeamsWaitForBackend;

 })(window);